(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lv-hair-care-quiz"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const quizSection = document.querySelector('[data-quiz-section]');
    if (!quizSection) return;

    // Translation helper - reads data-t-* attributes from the quiz section
    const t = {};
    for (const [key, value] of Object.entries(quizSection.dataset)) {
      if (key.startsWith('t')) {
        // Convert tAddToCart -> addToCart
        const tKey = key.charAt(1).toLowerCase() + key.slice(2);
        t[tKey] = value;
      }
    }

    // Additional translations from JSON block (for JS-only strings)
    const quizTranslationsEl = document.querySelector('[data-quiz-translations]');
    const quizT = quizTranslationsEl ? JSON.parse(quizTranslationsEl.textContent) : {};

    // TESTING FEATURE: Skip quiz and load recommendations directly
    // Set to true to enable testing mode
    const TESTING_MODE = false; // Change to true to enable testing

    // Theme event for cart updates
    const ThemeEvents = {
      cartUpdate: 'cart:update',
    };

    // Cart update event class
    class CartUpdateEvent extends Event {
      constructor(resource, sourceId, data) {
        super(ThemeEvents.cartUpdate, { bubbles: true });
        this.detail = {
          resource,
          sourceId,
          data: {
            ...data,
          },
        };
      }
    }

    // Helper function to resize Shopify image URLs
    const resizeImage = (url, size = '400x400') => {
      if (!url) return '';

      try {
        const parts = url.split('.');
        const extension = parts.pop();
        return `${parts.join('.')}_${size}.${extension}`;
      } catch (error) {
        console.error('Error resizing image:', error);
        return url;
      }
    };

    const form = quizSection.querySelector('[data-quiz-form]');
    const steps = form.querySelectorAll('[data-step]');
    const prevBtn = form.querySelector('[data-quiz-prev]');
    const submitBtn = form.querySelector('[data-quiz-submit]');
    const progressFill = quizSection.querySelector('[data-progress-fill]');
    const progressBar = quizSection.querySelector('.quiz-progress');
    const currentStepSpan = quizSection.querySelector('[data-current-step]');
    const statusElement = quizSection.querySelector('[data-quiz-status]');

    let currentStep = 1;
    const totalSteps = 6; // Exclude results step from count
    const quizAnswers = {};

    // Product handle mapping for each product line
    const productLineMapping = {
      'Maximum Volume': {
        title: 'Maximum Volume',
        handles: ['coffret-systeme-up-maximum-volume'],
      },
      Antirosette: {
        title: 'Antirosette',
        handles: ['antirosette'],
      },
      Antistatique: {
        title: 'Antistatique',
        handles: ['antistatique'],
      },
      Fixatifs: {
        title: 'Fixatifs',
        handles: ['fixatif-up', 'fixatif-tenue-moyenne'],
      },
      Nimbus: {
        title: 'Nimbus',
        handles: ['nimbus'],
      },
      Recréer: {
        title: 'Recréer',
        handles: ['coffret-recreer', 'shampoing-recreer', 'traitement-recreer-n-2'],
      },
      'Gamme Coloration': {
        title: 'Gamme Coloration',
        handles: ['coloration-shampoing', 'coloration-revitalisant', 'bouclier-solaire'],
      },
      'Bouclier Solaire': {
        title: 'Bouclier Solaire',
        handles: ['bouclier-solaire'],
      },
      'Sans Yellow': {
        title: 'Sans Yellow',
        handles: [
          'coffret-sans-yellow',
          'sans-yellow-shampooing-300ml',
          'revitalisant-sans-yellow',
          'traitement-proteine-blonds-400ml',
          'serum-reparateur-sans-yellow',
          'peigne-demelant-sans-yellow',
        ],
      },
      'No Rouge': {
        title: 'No Rouge',
        handles: ['no-rouge-shampoing', 'no-rouge-revitalisant'],
      },
      'No Flakes': {
        title: 'No Flakes',
        handles: ['shampoing-no-flakes'],
      },
      'Stay Clean': {
        title: 'Stay Clean',
        handles: ['stay-clean-shampoing'],
      },
      Sudoblok: {
        title: 'Sudoblok',
        handles: ['sudoblok'],
      },
      Sensible: {
        title: 'Sensible',
        handles: ['sensible-revitalisant', 'sensible-shampooing'],
      },
      '4 Nature': {
        title: '4 Nature',
        handles: ['shampoing-4-nature', '4-nature-revitalisant'],
      },
    };

    // Initialize
    console.log('Quiz initializing with', steps.length, 'steps');
    steps.forEach((step, index) => {
      console.log('Step', index + 1, ':', step.dataset.step, 'classes:', step.className);
      if (index === 0) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });

    goToStep(1); // Ensure first step is shown
    updateProgress();
    updateNavigationButtons();

    // Apply many-options class for crowded layouts
    steps.forEach((step) => {
      const answerOptions = step.querySelector('.answer-options');
      const optionCount = answerOptions ? answerOptions.querySelectorAll('.answer-option').length : 0;

      if (optionCount > 6) {
        answerOptions.classList.add('many-options');
      }
    });

    // Enhanced keyboard navigation
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && currentStep === 5) {
        // Allow escape from results to go back
        goToStep(currentStep - 1);
      }
    });

    // Handle answer selection with auto-advance
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-quiz-answer')) {
        const stepElement = e.target.closest('[data-step]');
        const stepNumber = parseInt(stepElement.dataset.step);
        const questionName = e.target.name;

        // Handle multiple selections for step 3 (hair_state) and step 5 (main_concern)
        if (questionName === 'hair_state' || questionName === 'main_concern') {
          if (!quizAnswers[questionName]) {
            quizAnswers[questionName] = [];
          }

          if (e.target.checked) {
            quizAnswers[questionName].push(e.target.value);
          } else {
            const index = quizAnswers[questionName].indexOf(e.target.value);
            if (index > -1) {
              quizAnswers[questionName].splice(index, 1);
            }
          }

          // Update step 3 or step 5 next button state
          if (questionName === 'hair_state') {
            updateStep3NextButton();
          } else if (questionName === 'main_concern') {
            updateStep5NextButton();
          }
        } else {
          // Single selection for other questions
          quizAnswers[questionName] = e.target.value;

          // Auto-advance to next step after a short delay
          if (stepNumber === currentStep && stepNumber < totalSteps) {
            setTimeout(() => {
              goToStep(currentStep + 1);
            }, 700); // Slightly longer delay to show the selection animation
          }
        }

        // Announce selection to screen readers
        if (statusElement) {
          statusElement.textContent = `Selected: ${e.target.closest('label').textContent.trim()}`;
        }
      }
    });

    // Handle clicks on radio buttons to fix re-selection issue (without dispatching change events)
    form.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-quiz-answer') && e.target.type === 'radio') {
        const stepElement = e.target.closest('[data-step]');
        const stepNumber = parseInt(stepElement.dataset.step);
        const questionName = e.target.name;

        // Only handle single selection questions (exclude hair_state and main_concern)
        if (questionName !== 'hair_state' && questionName !== 'main_concern') {
          // Check if this radio button is already selected (re-selection case)
          if (e.target.checked && quizAnswers[questionName] === e.target.value) {
            // This is a re-selection, manually trigger auto-advance
            if (stepNumber === currentStep && stepNumber < totalSteps) {
              setTimeout(() => {
                goToStep(currentStep + 1);
              }, 700);
            }
          }
        }
      }
    });

    // Enhanced email input handling
    const emailInput = form.querySelector('[data-quiz-email]');
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        const isValid = this.validity.valid && this.value.trim();

        // Update next button state for email step
        if (currentStep === 6) {
          updateNavigationButtons();
        }
      });

      emailInput.addEventListener('invalid', function (e) {
        e.preventDefault();
        if (statusElement) {
          statusElement.textContent = quizT.invalidEmail || 'Please enter a valid email address';
        }
      });
    }

    // Product line calculation logic - ONLY based on step 5 (main_concern)
    function calculateProductLineScores() {
      const productLines = {};
      const weightsBreakdown = {};

      // Only use main_concern (step 5) for product recommendations
      if (quizAnswers.main_concern && Array.isArray(quizAnswers.main_concern)) {
        const allProductLines = [];

        quizAnswers.main_concern.forEach((concernValue) => {
          const selectedInput = form.querySelector(`input[name="main_concern"][value="${concernValue}"]`);
          if (selectedInput && selectedInput.hasAttribute('data-product-lines')) {
            const productLinesString = selectedInput.getAttribute('data-product-lines');
            const lines = productLinesString.split(',').map((line) => line.trim());
            allProductLines.push(...lines);
          }
        });

        // Add scores for each unique product line
        const uniqueLines = [...new Set(allProductLines)];
        uniqueLines.forEach((line) => {
          if (!productLines[line]) {
            productLines[line] = 0;
          }
          productLines[line] += 1; // Each concern gets equal weight
        });

        // Store breakdown for debugging
        weightsBreakdown.main_concern = {
          answer: quizAnswers.main_concern.join(', '),
          weight: 1,
          productLines: uniqueLines,
          score: quizAnswers.main_concern.length,
        };
      }

      return { productLines, weightsBreakdown };
    }

    // Handle previous button
    prevBtn.addEventListener('click', function () {
      if (currentStep > 1) {
        goToStep(currentStep - 1);
      }
    });

    // Handle step 3 next button
    const step3NextBtn = form.querySelector('[data-step-3-next]');
    if (step3NextBtn) {
      step3NextBtn.addEventListener('click', function () {
        if (currentStep === 3) {
          goToStep(4);
        }
      });
    }

    // Handle step 5 next button
    const step5NextBtn = form.querySelector('[data-step-5-next]');
    if (step5NextBtn) {
      step5NextBtn.addEventListener('click', function () {
        if (currentStep === 5) {
          goToStep(6);
        }
      });
    }

    // Step 6 (email) Next button - shows results
    const step6NextBtn = form.querySelector('[data-step-6-next]');
    if (step6NextBtn) {
      step6NextBtn.addEventListener('click', async function () {
        if (currentStep === 6) {
          goToStep(totalSteps + 1); // Go to results
          await showResults(); // Load the results
        }
      });
    }

    // Function to restore previous selections when navigating back to a step
    function restoreStepSelections(step) {
      const targetStep = form.querySelector(`[data-step="${step}"]`);
      if (!targetStep) return;

      // Get all inputs in this step
      const inputs = targetStep.querySelectorAll('input[data-quiz-answer]');

      inputs.forEach((input) => {
        const questionName = input.name;
        const inputValue = input.value;

        // Check if we have a saved answer for this question
        if (quizAnswers[questionName]) {
          if (
            (questionName === 'hair_state' || questionName === 'main_concern') &&
            Array.isArray(quizAnswers[questionName])
          ) {
            // Handle multiple selections (checkboxes)
            input.checked = quizAnswers[questionName].includes(inputValue);
          } else if (questionName === 'email') {
            // Handle email input
            input.value = quizAnswers[questionName];
          } else {
            // Handle single selections (radio buttons)
            input.checked = quizAnswers[questionName] === inputValue;
          }
        }
      });

      // Update step 3 or step 5 next button state if we're on those steps
      if (step === 3) {
        updateStep3NextButton();
      } else if (step === 5) {
        updateStep5NextButton();
      }
    }

    // Function to update step 3 next button state
    function updateStep3NextButton() {
      const step3NextBtn = form.querySelector('[data-step-3-next]');
      if (!step3NextBtn) return;

      const hasSelections = quizAnswers.hair_state && quizAnswers.hair_state.length > 0;
      step3NextBtn.disabled = !hasSelections;

      // Update help text
      const helpText = form.querySelector('#step-3-help');
      if (helpText) {
        if (hasSelections) {
          helpText.textContent = t.selected.replace('{{ items }}', quizAnswers.hair_state.join(', '));
          helpText.style.color = 'rgb(var(--color-foreground-rgb) / 0.8)';
        } else {
          helpText.textContent = t.selectOne;
          helpText.style.color = 'rgb(var(--color-foreground-rgb) / 0.6)';
        }
      }
    }

    // Function to update step 5 next button state
    function updateStep5NextButton() {
      const step5NextBtn = form.querySelector('[data-step-5-next]');
      if (!step5NextBtn) return;

      const hasSelections = quizAnswers.main_concern && quizAnswers.main_concern.length > 0;
      const tooManySelections = quizAnswers.main_concern && quizAnswers.main_concern.length > 2;
      step5NextBtn.disabled = !hasSelections || tooManySelections;

      // Update help text
      const helpText = form.querySelector('#step-5-help');
      if (helpText) {
        if (tooManySelections) {
          helpText.textContent = t.maxConcerns;
          helpText.style.color = 'rgb(220, 53, 69)'; // Red color for error
        } else if (hasSelections) {
          helpText.textContent = t.selected.replace('{{ items }}', quizAnswers.main_concern.join(', '));
          helpText.style.color = 'rgb(var(--color-foreground-rgb) / 0.8)';
        } else {
          helpText.textContent = t.selectConcerns;
          helpText.style.color = 'rgb(var(--color-foreground-rgb) / 0.6)';
        }
      }
    }

    // Handle automatic progression to results
    async function showResults() {
      try {
        // Collect email
        if (emailInput) {
          quizAnswers.email = emailInput.value.trim();
        }

        // Save quiz answers to Shopify
        await saveQuizAnswers();

        // Load recommendations
        await loadRecommendations();

        if (statusElement) {
          statusElement.textContent = quizT.quizComplete || 'Quiz completed!';
        }
      } catch (error) {
        console.error('Quiz submission error:', error);
        if (statusElement) {
          statusElement.textContent = quizT.quizError || 'Error loading results';
        }
      }
    }

    // Enhanced copy discount code functionality
    const copyBtn = quizSection.querySelector('[data-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async function () {
        const codeValue = this.parentElement.querySelector('.code-value').textContent;

        try {
          await navigator.clipboard.writeText(codeValue);
          const originalText = this.textContent;
          this.textContent = quizT.copied || 'Copied!';
          this.setAttribute('aria-label', (quizT.codeCopied || 'Code copied') + ' ' + codeValue);

          if (statusElement) {
            statusElement.textContent = (quizT.codeCopied || 'Code copied') + ' ' + codeValue;
          }

          setTimeout(() => {
            this.textContent = originalText;
            this.setAttribute('aria-label', (quizT.copyCodeLabel || 'Copy discount code') + ' ' + codeValue);
          }, 2000);
        } catch (error) {
          console.error('Copy failed:', error);
          if (statusElement) {
            statusElement.textContent = quizT.copyFailed || 'Could not copy code';
          }
        }
      });
    }

    function goToStep(step) {
      console.log('goToStep called with step:', step, 'current step:', currentStep);
      // Validate step bounds
      if (step < 1 || step > steps.length) return;

      // Hide all steps
      steps.forEach((s) => s.classList.remove('active'));

      // Show current step
      const targetStep = form.querySelector(`[data-step="${step}"]`);
      if (targetStep) {
        targetStep.classList.add('active');
        currentStep = step;

        // Restore previous selections when navigating back
        restoreStepSelections(step);

        // Update progress and navigation
        updateProgress();
        updateNavigationButtons();

        // Focus management
        if (step <= totalSteps) {
          // Focus on first interactive element in the step
          const firstInput = targetStep.querySelector('input[type="radio"], input[type="email"]');
          if (firstInput) {
            setTimeout(() => firstInput.focus(), 100);
          }
        }

        // Announce step change to screen readers
        if (statusElement) {
          if (step <= totalSteps) {
            statusElement.textContent = quizT.stepProgress ? quizT.stepProgress.replace('__STEP__', step).replace('__TOTAL__', totalSteps) : `Step ${step} of ${totalSteps}`;
          } else {
            statusElement.textContent = quizT.viewingResults || 'Quiz completed';
          }
        }
      }
    }

    // (Removed JS equal-height logic; handled via CSS)

    function updateProgress() {
      if (currentStep <= totalSteps) {
        const progress = ((currentStep - 1) / (totalSteps - 1)) * 100;
        progressFill.style.width = Math.max(16.67, progress) + '%'; // Minimum 16.67% for step 1
        progressBar.setAttribute('aria-valuenow', currentStep);
        currentStepSpan.textContent = currentStep;
      } else {
        // Results step
        progressFill.style.width = '100%';
        progressBar.setAttribute('aria-valuenow', totalSteps);
      }
    }

    function updateNavigationButtons() {
      // Previous button - show for steps 2-6, hide on results
      if (currentStep > 1 && currentStep <= totalSteps) {
        prevBtn.style.display = 'block';
      } else {
        prevBtn.style.display = 'none';
      }

      // Submit button - only show on results step
      if (currentStep === totalSteps + 1) {
        submitBtn.style.display = 'none'; // Hide submit button on results too
      } else {
        submitBtn.style.display = 'none';
      }

      // Step 6 (email) next button state
      if (currentStep === 6) {
        const step6NextBtn = form.querySelector('[data-step-6-next]');
        const emailInput = form.querySelector('[data-quiz-email]');
        if (step6NextBtn && emailInput) {
          const isValid = emailInput.validity.valid && emailInput.value.trim();
          step6NextBtn.disabled = !isValid;
        }
      }
    }

    async function saveQuizAnswers() {
      try {
        // Get newsletter checkbox value
        const newsletterCheckbox = form.querySelector('[name="newsletter"]');
        const newsletter = newsletterCheckbox ? newsletterCheckbox.checked : false;

        // Prepare quiz data
        const quizData = {
          email: quizAnswers.email,
          answers: {
            hair_diameter: quizAnswers.hair_diameter,
            hair_texture: quizAnswers.hair_texture,
            hair_state: Array.isArray(quizAnswers.hair_state)
              ? quizAnswers.hair_state.join(', ')
              : quizAnswers.hair_state,
            hair_color: quizAnswers.hair_color,
            main_concern: Array.isArray(quizAnswers.main_concern)
              ? quizAnswers.main_concern.join(', ')
              : quizAnswers.main_concern,
          },
          newsletter: newsletter,
          customerId: window.Shopify?.customer?.id || null,
        };

        console.log('Saving quiz answers:', quizData);

        const functionUrl =
          'https://faas-tor1-70ca848e.doserverless.co/api/v1/web/fn-5f8691a7-ed75-42aa-a79a-44441be3c4e7/update-customer/update-quiz-answers';

        const response = await fetch(functionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Shop-Domain': window.Shopify?.shop || 'luc-vincent.myshopify.com',
          },
          body: JSON.stringify(quizData),
        });

        const result = await response.json();

        if (result.success) {
          console.log('Quiz answers saved successfully:', result);
        } else {
          console.error('Failed to save quiz answers:', result);
        }
      } catch (error) {
        console.error('Error saving quiz answers:', error);
        // Don't block the quiz completion if saving fails
      }
    }

    async function loadRecommendations() {
      const productsContainer = quizSection.querySelector('[data-recommended-products]');
      if (!productsContainer) return;

      productsContainer.innerHTML = `<p>${t.loading}</p>`;

      try {
        // Calculate recommended product lines
        const { productLines } = calculateProductLineScores();

        // Get top 3 product lines sorted by score
        const topProductLines = Object.entries(productLines)
          .sort(([, a], [, b]) => b - a)
          .slice(0, 3)
          .map(([line]) => line);

        // Collect all product handles from top lines and build handle-to-group map
        const productHandles = new Set();
        const handleToGroupKey = {};
        topProductLines.forEach((line) => {
          const group = productLineMapping[line];
          if (group && group.handles) {
            group.handles.forEach((handle) => {
              productHandles.add(handle);
              handleToGroupKey[handle] = line;
            });
          }
        });

        // Fetch products from Shopify
        const products = await Promise.all(
          Array.from(productHandles).map((handle) =>
            fetch(`/products/${handle}.js`)
              .then((res) => {
                if (!res.ok) {
                  throw new Error(`Product not found: ${handle}`);
                }
                return res.json();
              })
              .then((product) => {
                // Validate product has variants
                if (!product.variants || product.variants.length === 0) {
                  console.warn(`Product ${handle} has no variants`);
                  return null;
                }
                return product;
              })
              .catch((err) => {
                console.error(`Error fetching product ${handle}:`, err);
                return null;
              }),
          ),
        );

        // Filter out failed fetches and products without variants
        const validProducts = products.filter((p) => p !== null);

        if (validProducts.length === 0) {
          productsContainer.innerHTML = `<p>${t.noProductsFound}</p>`;
          return;
        }

        // Store quantities for stepper products
        const selectedQuantities = {};

        // Partition products into coffrets and others
        const coffrets = validProducts.filter((p) => p.handle.startsWith('coffret-'));
        const otherProducts = validProducts.filter((p) => !p.handle.startsWith('coffret-'));

        // Group other products by their product line
        const groupedProducts = {};
        otherProducts.forEach((product) => {
          const groupKey = handleToGroupKey[product.handle];
          if (groupKey) {
            if (!groupedProducts[groupKey]) {
              groupedProducts[groupKey] = [];
            }
            groupedProducts[groupKey].push(product);
          }
        });

        // Helper to render a product card
        const renderProductCard = (product, isCoffret) => {
          const cardHTML = `
            <article class="product-card">
              <div class="product-image-container">
                <img 
                  src="${resizeImage(product.featured_image, '400x400')}" 
                  alt="${(product.title || 'Product').replace(/"/g, '&quot;')}"
                  loading="lazy"
                  width="400"
                  height="400"
                />
                ${!isCoffret ? '<span class="price-badge" style="display: none;"></span>' : ''}
              </div>
              <h3>${product.title || 'Product'}</h3>
              <div class="product-price-container">
                <span class="product-price" data-original-price="${product.price || 0}">${((product.price || 0) / 100).toFixed(2)} $</span>
                <span class="product-price-compare" style="display: none;"></span>
              </div>
              ${
                isCoffret
                  ? `<button 
                      class="button quiz-add-to-cart" 
                      type="button"
                      data-product-id="${product.variants[0].id}"
                      data-is-coffret="true"
                      aria-label="Add ${(product.title || 'product').replace(/"/g, '&quot;')} to cart"
                    >
                      ${t.addToCart}
                    </button>`
                  : `<div class="quiz-quantity-stepper" data-product-handle="${product.handle}">
                      <button 
                        type="button" 
                        class="stepper-btn stepper-minus" 
                        aria-label="-"
                      >
                        −
                      </button>
                      <span class="stepper-count" data-count="0">0</span>
                      <button 
                        type="button" 
                        class="stepper-btn stepper-plus" 
                        data-variant-id="${product.variants[0].id}"
                        aria-label="+"
                      >
                        +
                      </button>
                    </div>`
              }
            </article>
          `;
          return cardHTML;
        };

        // Build final HTML
        let finalHTML = '';

        // Render coffrets first if any
        if (coffrets.length > 0) {
          finalHTML +=
            `<div class="product-group"><h3 class="group-heading">${t.coffrets}</h3><div class="product-group-items">`;
          finalHTML += coffrets.map((p) => renderProductCard(p, true)).join('');
          finalHTML += '</div></div>';
        }

        // Add pricing header after coffrets
        if (coffrets.length > 0) {
          finalHTML += `
            <div class="quiz-pricing-header">
              <h2 class="quiz-pricing-title">${t.pricingTitle}</h2>
              <div class="quiz-pricing-tiers">
                <div class="pricing-tier">
                  <div class="tier-quantity">${t.productsCount.replace('{{ count }}', '2')}</div>
                  <div class="tier-discount">${t.discountLabel.replace('{{ percent }}', '5.0')}</div>
                </div>
                <div class="pricing-tier">
                  <div class="tier-quantity">${t.productsCount.replace('{{ count }}', '3')}</div>
                  <div class="tier-discount">${t.discountLabel.replace('{{ percent }}', '10.0')}</div>
                </div>
                <div class="pricing-tier">
                  <div class="tier-quantity">${t.productsCount.replace('{{ count }}', '4-5')}</div>
                  <div class="tier-discount">${t.discountLabel.replace('{{ percent }}', '15.0')}</div>
                </div>
                <div class="pricing-tier">
                  <div class="tier-quantity">${t.orMoreProducts.replace('{{ count }}', '6')}</div>
                  <div class="tier-discount">${t.discountLabel.replace('{{ percent }}', '20.0')}</div>
                </div>
              </div>
            </div>
          `;
        }

        // Start layout wrapper with cart summary
        finalHTML += `
          <div class="quiz-recommendations-layout">
            <div class="quiz-recommendations-main">
        `;

        // Render grouped products
        topProductLines.forEach((lineKey) => {
          const productsInGroup = groupedProducts[lineKey];
          if (productsInGroup && productsInGroup.length > 0) {
            const groupTitle = productLineMapping[lineKey]?.title || lineKey;
            finalHTML += `<div class="product-group"><h3 class="group-heading">${groupTitle}</h3><div class="product-group-items">`;
            finalHTML += productsInGroup.map((p) => renderProductCard(p, false)).join('');
            finalHTML += '</div></div>';
          }
        });

        // Close main content div and add cart summary
        finalHTML += `
            </div>
            <div class="quiz-cart-summary">
              <button class="cart-summary__toggle" type="button">
                <span>${t.validatePack} <span class="cart-item-count-badge-mobile">0</span></span>
                <svg class="cart-toggle-icon" width="16" height="16" viewBox="0 0 16 16">
                  <path d="M4 6l4 4 4-4" stroke="currentColor" fill="none" stroke-width="2"/>
                </svg>
              </button>
              
              <div class="cart-summary__content">
                <div class="cart-summary__header">
                  <h3 class="cart-summary__title">${t.myPack}</h3>
                  <span class="cart-item-count-badge">0</span>
                </div>

                <div class="cart-summary__body">
                  <div class="cart-summary__items" data-state="empty">
                    <div class="cart-items-empty">
                      ${t.startSelection}
                    </div>
                  </div>

                  <div class="cart-progress">
                    <div class="cart-progress__label">
                      ${t.addProductsForDiscount.replace('{{ count }}', '2').replace('{{ percent }}', '5')}
                    </div>
                    <div class="cart-progress__segments">
                      <span class="cart-progress__segment" data-step="1"></span>
                      <span class="cart-progress__segment" data-step="2"></span>
                      <span class="cart-progress__segment" data-step="3"></span>
                      <span class="cart-progress__segment" data-step="4"></span>
                      <span class="cart-progress__segment" data-step="5"></span>
                      <span class="cart-progress__segment" data-step="6"></span>
                    </div>
                  </div>
                </div>
                
                <div class="cart-summary__pricing" style="display: none;">
                  <div class="pricing-row">
                    <span>${t.subtotal}</span>
                    <span class="cart-subtotal">0,00 $</span>
                  </div>
                  <div class="pricing-row discount-row" style="display: none;">
                    <span>${t.discount}</span>
                    <span class="cart-summary-discount">-0,00 $</span>
                  </div>
                  <div class="pricing-row total-row">
                    <span>${t.total}</span>
                    <span class="cart-total">0,00 $</span>
                  </div>
                </div>
                
                <button type="button" class="button quiz-add-all-to-cart" disabled>
                  ${t.selectProducts}
                </button>
              </div>
            </div>
          </div>
        `;

        productsContainer.innerHTML = finalHTML;

        // Add click handlers for coffret add to cart buttons only
        productsContainer.querySelectorAll('.quiz-add-to-cart[data-is-coffret="true"]').forEach((btn) => {
          btn.addEventListener('click', async function () {
            const variantId = this.dataset.productId;
            const originalText = this.textContent;

            this.disabled = true;
            this.textContent = t.adding;

            try {
              // Create FormData with variant ID and quantity
              const formData = new FormData();
              formData.append('id', variantId);
              formData.append('quantity', '1');

              // Add to cart using theme's standard approach
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
              });

              if (!response.ok) {
                throw new Error('Failed to add to cart');
              }

              const data = await response.json();

              // Dispatch theme's CartUpdateEvent for cart icon and drawer updates
              document.dispatchEvent(
                new CartUpdateEvent(data, 'quiz-recommendations', {
                  source: 'hair-care-quiz',
                  itemCount: data.item_count,
                }),
              );

              this.textContent = t.added;

              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 2000);
            } catch (error) {
              console.error('Error adding to cart:', error);
              this.textContent = t.error;

              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 2000);
            }
          });
        });

        // Add stepper logic for non-coffret products
        productsContainer.querySelectorAll('.quiz-quantity-stepper').forEach((stepper) => {
          const handle = stepper.dataset.productHandle;
          const minusBtn = stepper.querySelector('.stepper-minus');
          const plusBtn = stepper.querySelector('.stepper-plus');
          const countSpan = stepper.querySelector('.stepper-count');

          // Initialize quantity
          selectedQuantities[handle] = 0;

          // Plus button
          plusBtn.addEventListener('click', () => {
            selectedQuantities[handle]++;
            countSpan.textContent = selectedQuantities[handle];
            countSpan.dataset.count = selectedQuantities[handle];
            minusBtn.disabled = false;
            if (window.updateQuizPricing) {
              window.updateQuizPricing();
            }
            if (window.updateQuizCartSummary) {
              window.updateQuizCartSummary();
            }
          });

          // Minus button
          minusBtn.addEventListener('click', () => {
            if (selectedQuantities[handle] > 0) {
              selectedQuantities[handle]--;
              countSpan.textContent = selectedQuantities[handle];
              countSpan.dataset.count = selectedQuantities[handle];

              if (selectedQuantities[handle] === 0) {
                minusBtn.disabled = true;
              }
              if (window.updateQuizPricing) {
                window.updateQuizPricing();
              }
              if (window.updateQuizCartSummary) {
                window.updateQuizCartSummary();
              }
            }
          });

          // Disable minus initially
          minusBtn.disabled = true;
        });

        // Mobile toggle handler
        const cartToggle = productsContainer.querySelector('.cart-summary__toggle');
        const cartSummary = productsContainer.querySelector('.quiz-cart-summary');

        if (cartToggle && cartSummary) {
          // Ensure cart starts collapsed on mobile
          if (window.innerWidth < 1024) {
            cartSummary.classList.remove('is-expanded');
          }

          cartToggle.addEventListener('click', () => {
            cartSummary.classList.toggle('is-expanded');
          });
        }

        // Add All to Cart button handler
        const addAllToCartBtn = productsContainer.querySelector('.quiz-add-all-to-cart');
        if (addAllToCartBtn) {
          addAllToCartBtn.addEventListener('click', async function () {
            const originalText = this.textContent;
            this.disabled = true;
            this.textContent = t.adding;

            try {
              // Use hardcoded bundle variant ID
              const bundleVariantId = '51163317764398';

              // Collect selected products for properties
              const selectedItems = [];
              const productProperties = {};

              Object.entries(selectedQuantities).forEach(([handle, quantity]) => {
                if (quantity > 0) {
                  const stepper = productsContainer.querySelector(`[data-product-handle="${handle}"]`);
                  if (stepper) {
                    const plusBtn = stepper.querySelector('.stepper-plus');
                    const variantId = plusBtn.dataset.variantId;
                    const product = findProductByHandle(handle);

                    if (variantId && product) {
                      // Add to array for __hairquiz-bundle property
                      selectedItems.push({
                        variantId: variantId,
                        quantity: quantity,
                        price: ((product.price || 0) / 100).toFixed(2),
                      });

                      // Add individual product property
                      productProperties['__hairquiz-item:' + product.title] = `x${quantity}`;
                    }
                  }
                }
              });

              if (selectedItems.length === 0) {
                throw new Error(t.noProducts);
              }

              // Calculate discount
              const pricing = calculateTotalPricing();

              // Build properties object
              const properties = {
                '__hairquiz-bundle': JSON.stringify(selectedItems),
                '__hairquiz-discount': `${pricing.discountPercentage}%`,
                '__hairquiz-product-title': 'Your custom bundle',
                ...productProperties,
              };

              // Add bundle product to cart
              const formData = {
                items: [
                  {
                    id: bundleVariantId,
                    quantity: 1,
                    properties: properties,
                  },
                ],
              };

              const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
              });

              if (!response.ok) {
                throw new Error(t.errorAdding);
              }

              const addResponse = await response.json();

              // Fetch updated cart data to get the full cart state
              const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
              const cartData = await cartResponse.json();

              // Dispatch theme's CartUpdateEvent for cart icon and drawer updates
              document.dispatchEvent(
                new CartUpdateEvent(cartData, 'quiz-multi-add', {
                  source: 'hair-care-quiz',
                  itemCount: cartData.item_count,
                }),
              );

              // Show success message
              this.textContent = t.addedFull;
              setTimeout(() => {
                // Reset quantities and update UI
                Object.keys(selectedQuantities).forEach((handle) => {
                  adjustQuantityFromCart(handle, -selectedQuantities[handle]);
                });

                // Update pricing and cart summary
                if (window.updateQuizPricing) {
                  window.updateQuizPricing();
                }
                if (window.updateQuizCartSummary) {
                  window.updateQuizCartSummary();
                }
              }, 2000);
            } catch (error) {
              console.error('Error adding to cart:', error);
              this.textContent = t.errorRetry;
              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 2000);
            }
          });
        }

        // Add dynamic pricing function
        function updatePricing() {
          // Calculate total quantity from non-coffret products only
          let totalQuantity = 0;
          Object.values(selectedQuantities).forEach((qty) => {
            totalQuantity += qty;
          });

          // Determine discount tier
          let discountPercentage = 0;
          if (totalQuantity >= 6) {
            discountPercentage = 20;
          } else if (totalQuantity >= 4) {
            discountPercentage = 15;
          } else if (totalQuantity === 3) {
            discountPercentage = 10;
          } else if (totalQuantity === 2) {
            discountPercentage = 5;
          }

          // Update all non-coffret product prices and badges
          productsContainer.querySelectorAll('.product-card').forEach((card) => {
            const priceElement = card.querySelector('.product-price');
            const compareElement = card.querySelector('.product-price-compare');
            const badgeElement = card.querySelector('.price-badge');

            if (!priceElement || !badgeElement) return; // Skip coffrets

            const originalPrice = parseInt(priceElement.dataset.originalPrice);
            const discountedPrice = originalPrice * (1 - discountPercentage / 100);

            if (discountPercentage > 0) {
              // Show discount pricing
              priceElement.textContent = `${(discountedPrice / 100).toFixed(2)} $`;
              compareElement.textContent = `${(originalPrice / 100).toFixed(2)} $`;
              compareElement.style.display = 'block';
              compareElement.style.opacity = '.5';
              badgeElement.textContent = quizT.discountBadge ? quizT.discountBadge.replace('__PERCENT__', discountPercentage) : `${discountPercentage}% OFF`;
              badgeElement.style.display = 'block';
            } else {
              // Reset to original pricing
              priceElement.textContent = `${(originalPrice / 100).toFixed(2)} $`;
              compareElement.style.display = 'none';
              badgeElement.style.display = 'none';
            }
          });
        }

        // Store updatePricing function for use in event handlers
        window.updateQuizPricing = updatePricing;

        // Cart Summary Functions
        function updateCartSummary() {
          const summaryContainer = quizSection.querySelector('.cart-summary__items');
          if (!summaryContainer) return;

          const summaryBody = quizSection.querySelector('.cart-summary__body');
          const emptyState = summaryContainer.querySelector('.cart-items-empty');
          const progressLabel = quizSection.querySelector('.cart-progress__label');
          const progressSegments = quizSection.querySelectorAll('.cart-progress__segment');

          const existingItems = summaryContainer.querySelectorAll('.cart-item');
          existingItems.forEach((item) => item.remove());

          let hasItems = false;
          const pricing = calculateTotalPricing();
          const totalItems = Object.values(selectedQuantities).reduce((a, b) => a + b, 0);

          // Add selected products to summary
          Object.entries(selectedQuantities).forEach(([handle, quantity]) => {
            if (quantity > 0) {
              hasItems = true;
              const product = findProductByHandle(handle);
              if (product) {
                const itemElement = createCartItemElement(product, quantity, pricing.discountPercentage);
                summaryContainer.appendChild(itemElement);
              }
            }
          });

          // Toggle empty state visuals
          summaryContainer.dataset.state = hasItems ? 'filled' : 'empty';
          if (emptyState) emptyState.style.display = hasItems ? 'none' : 'block';
          if (summaryBody) summaryBody.classList.toggle('cart-summary__body--has-items', hasItems);

          // Update pricing display
          updateCartPricing(pricing);

          // Update tier progress message
          updateTierProgressMessage(pricing);

          // Update progress bar
          updateProgressBar(pricing);

          // Update progress segments
          if (progressSegments) {
            progressSegments.forEach((segment) => {
              const step = parseInt(segment.dataset.step, 10) || 0;
              segment.classList.toggle('is-active', totalItems >= step);
            });
          }

          // Update cart progress label
          if (progressLabel) {
            const nextTierForLabel = getNextTier(pricing.totalQuantity);
            if (nextTierForLabel && hasItems) {
              const itemsNeeded = nextTierForLabel.minQuantity - pricing.totalQuantity;
              const tpl = itemsNeeded === 1 ? t.addMoreSingular : t.addMorePlural;
              progressLabel.innerHTML = tpl.replace('{{ count }}', itemsNeeded).replace('{{ percent }}', nextTierForLabel.discountPercentage);
              progressLabel.parentElement.style.display = 'block';
            } else if (pricing.totalQuantity >= 6 && hasItems) {
              progressLabel.innerHTML = t.maxDiscount;
              progressLabel.parentElement.style.display = 'block';
            } else if (!hasItems) {
              progressLabel.innerHTML = t.addProductsForDiscount.replace('{{ count }}', '2').replace('{{ percent }}', '5');
              progressLabel.parentElement.style.display = 'block';
            }
          }

          // Update item count badges
          updateItemCountBadges(totalItems);

          // Update add to cart button
          updateAddToCartButton(hasItems, totalItems, pricing);
        }

        function createCartItemElement(product, quantity, discountPercentage) {
          const item = document.createElement('div');
          item.className = 'cart-item';

          const originalPrice = (product.price || 0) * quantity;
          const discountedPrice = originalPrice * (1 - discountPercentage / 100);

          const imageUrl = product.featured_image ? `${product.featured_image}?width=120&height=120` : '';
          const variantId = product.variant_id || '';

          item.innerHTML = `
            <div class="cart-item__image-container">
              ${
                imageUrl
                  ? `<img src="${imageUrl}" alt="${product.title}" class="cart-item__image">`
                  : `<div class="cart-item__image cart-item__image--placeholder"></div>`
              }
              ${discountPercentage > 0 ? `<span class="cart-item__badge">-${discountPercentage}%</span>` : ''}
            </div>
            <div class="cart-item__content">
              <span class="cart-item__name">${product.title}</span>
              ${variantId ? `<span class="cart-item__variant">${variantId}</span>` : ''}
            </div>
            <div class="cart-item__pricing">
              <div class="cart-item__price-wrapper">
                ${
                  discountPercentage > 0
                    ? `<span class="cart-item__price cart-item__price--sale">${formatMoney(discountedPrice)}</span>
                       <span class="cart-item__price cart-item__price--compare">${formatMoney(originalPrice)}</span>`
                    : `<span class="cart-item__price">${formatMoney(originalPrice)}</span>`
                }
              </div>
              <div class="cart-item__quantity-controls">
                <button type="button" class="cart-item__quantity-btn" data-action="decrease" data-product-handle="${product.handle}">−</button>
                <span class="cart-item__quantity-value">${quantity}</span>
                <button type="button" class="cart-item__quantity-btn" data-action="increase" data-product-handle="${product.handle}">+</button>
              </div>
            </div>
          `;

          const decreaseBtn = item.querySelector('[data-action="decrease"]');
          const increaseBtn = item.querySelector('[data-action="increase"]');

          if (decreaseBtn) {
            decreaseBtn.addEventListener('click', () => {
              adjustQuantityFromCart(product.handle, -1);
            });
          }

          if (increaseBtn) {
            increaseBtn.addEventListener('click', () => {
              adjustQuantityFromCart(product.handle, 1);
            });
          }

          return item;
        }

        function formatMoney(amountInCents) {
          return `${(amountInCents / 100).toFixed(2)} $`;
        }

        function adjustQuantityFromCart(handle, delta) {
          if (typeof selectedQuantities[handle] !== 'number') {
            selectedQuantities[handle] = 0;
          }

          selectedQuantities[handle] = Math.max(0, selectedQuantities[handle] + delta);

          const stepper = quizSection.querySelector(`[data-product-handle="${handle}"]`);
          if (stepper) {
            const count = stepper.querySelector('.stepper-count');
            const minus = stepper.querySelector('.stepper-minus');
            if (count) {
              count.textContent = selectedQuantities[handle];
              count.dataset.count = selectedQuantities[handle];
            }
            if (minus) {
              minus.disabled = selectedQuantities[handle] === 0;
            }
          }

          if (window.updateQuizPricing) {
            window.updateQuizPricing();
          }
          if (window.updateQuizCartSummary) {
            window.updateQuizCartSummary();
          }
        }

        function calculateTotalPricing() {
          let totalQuantity = 0;
          let subtotal = 0;

          Object.entries(selectedQuantities).forEach(([handle, quantity]) => {
            if (quantity > 0) {
              const product = findProductByHandle(handle);
              if (product) {
                subtotal += (product.price || 0) * quantity;
                totalQuantity += quantity;
              }
            }
          });

          // Determine discount tier
          let discountPercentage = 0;
          if (totalQuantity >= 6) discountPercentage = 20;
          else if (totalQuantity >= 4) discountPercentage = 15;
          else if (totalQuantity === 3) discountPercentage = 10;
          else if (totalQuantity === 2) discountPercentage = 5;

          const discount = subtotal * (discountPercentage / 100);
          const total = subtotal - discount;

          return { subtotal, discount, total, discountPercentage, totalQuantity };
        }

        function updateCartPricing(pricing) {
          const subtotalEl = quizSection.querySelector('.cart-subtotal');
          const discountEl = quizSection.querySelector('.cart-summary-discount');
          const totalEl = quizSection.querySelector('.cart-total');
          const discountRow = quizSection.querySelector('.discount-row');
          const pricingSection = quizSection.querySelector('.cart-summary__pricing');

          // Hide the entire pricing section if there are no items
          if (pricingSection) {
            if (pricing.totalQuantity === 0) {
              pricingSection.style.display = 'none';
            } else {
              pricingSection.style.display = 'block';
            }
          }

          if (subtotalEl) subtotalEl.textContent = `${(pricing.subtotal / 100).toFixed(2)} $`;
          if (totalEl) totalEl.textContent = `${(pricing.total / 100).toFixed(2)} $`;

          if (discountEl && discountRow) {
            if (pricing.discount > 0) {
              discountEl.textContent = `-${(pricing.discount / 100).toFixed(2)} $`;
              discountRow.style.display = 'flex';
            } else {
              discountRow.style.display = 'none';
            }
          }
        }

        function updateAddToCartButton(hasItems, totalItems, pricing) {
          const button = quizSection.querySelector('.quiz-add-all-to-cart');
          if (!button) return;

          button.disabled = !hasItems;

          if (hasItems && pricing) {
            const totalPrice = (pricing.total / 100).toFixed(2);
            const originalPrice = (pricing.subtotal / 100).toFixed(2);

            if (pricing.discount > 0) {
              button.innerHTML = `${t.addAll} <span>${totalPrice} $ <span class="button-price-compare">${originalPrice} $</span></span>`;
            } else {
              button.innerHTML = `${t.addAll} <span>${totalPrice} $</span>`;
            }
          } else {
            button.textContent = t.selectProducts;
          }
        }

        function findProductByHandle(handle) {
          // Search through all loaded products to find by handle
          const allProducts = quizSection.querySelectorAll('[data-product-handle]');
          for (const productEl of allProducts) {
            if (productEl.dataset.productHandle === handle) {
              // Extract product data from DOM
              const title = productEl.closest('.product-card')?.querySelector('h3')?.textContent;
              const priceText = productEl.closest('.product-card')?.querySelector('.product-price')
                ?.dataset.originalPrice;
              const image = productEl.closest('.product-card')?.querySelector('img')?.src;

              return {
                handle: handle,
                title: title || 'Product',
                price: parseInt(priceText) || 0,
                featured_image: image,
              };
            }
          }
          return null;
        }

        function getNextTier(currentQuantity) {
          const tiers = [
            { minQuantity: 2, discountPercentage: 5 },
            { minQuantity: 3, discountPercentage: 10 },
            { minQuantity: 4, discountPercentage: 15 },
            { minQuantity: 6, discountPercentage: 20 },
          ];

          for (let tier of tiers) {
            if (currentQuantity < tier.minQuantity) {
              return tier;
            }
          }
          return null;
        }

        function getOrdinalText(num) {
          const ordinals = {
            2: '2ème',
            3: '3ème',
            4: '4ème',
            5: '5ème',
            6: '6ème',
            7: '7ème',
            8: '8ème',
          };
          return ordinals[num] || `${num}ème`;
        }

        function getPreviousTierMax(currentMin) {
          const tierMins = [0, 2, 3, 4, 6];
          const index = tierMins.indexOf(currentMin);
          return index > 0 ? tierMins[index - 1] : 0;
        }

        function updateTierProgressMessage(pricing) {
          const messageEl = quizSection.querySelector('.tier-progress-message');
          if (!messageEl) return;

          const nextTier = getNextTier(pricing.totalQuantity);

          if (nextTier && pricing.totalQuantity > 0) {
            const itemsNeeded = nextTier.minQuantity - pricing.totalQuantity;
            const ordinalText = getOrdinalText(nextTier.minQuantity);

            messageEl.querySelector('.tier-progress-text').innerHTML =
              (t.addMoreSingular || '').replace('{{ count }}', '1').replace('{{ percent }}', nextTier.discountPercentage);
            messageEl.style.display = 'flex';
          } else {
            messageEl.style.display = 'none';
          }
        }

        function updateProgressBar(pricing) {
          const progressFill = quizSection.querySelector('.tier-progress-bar-fill');
          const progressLabel = quizSection.querySelector('.tier-progress-label');
          const container = quizSection.querySelector('.tier-progress-bar-container');

          if (!progressFill || !progressLabel || !container) return;

          const nextTier = getNextTier(pricing.totalQuantity);

          if (nextTier && pricing.totalQuantity > 0) {
            const previousTierMax = getPreviousTierMax(nextTier.minQuantity);
            const range = nextTier.minQuantity - previousTierMax;
            const progress = pricing.totalQuantity - previousTierMax;
            const percentage = Math.min(100, (progress / range) * 100);

            progressFill.style.width = `${percentage}%`;

            const itemsNeeded = nextTier.minQuantity - pricing.totalQuantity;
            const tpl = itemsNeeded === 1 ? t.addMoreSingular : t.addMorePlural;
            progressLabel.innerHTML = tpl.replace('{{ count }}', itemsNeeded).replace('{{ percent }}', nextTier.discountPercentage);

            container.style.display = 'block';
          } else {
            // Hide progress bar when max discount is reached or no items
            container.style.display = 'none';
          }
        }

        function updateItemCountBadges(totalItems) {
          const desktopBadge = quizSection.querySelector('.cart-item-count-badge');
          const mobileBadge = quizSection.querySelector('.cart-item-count-badge-mobile');

          if (desktopBadge) desktopBadge.textContent = totalItems || '0';
          if (mobileBadge) mobileBadge.textContent = totalItems || '0';
        }

        // Store cart summary function for use in event handlers
        window.updateQuizCartSummary = updateCartSummary;
      } catch (error) {
        console.error('Error loading recommendations:', error);
        productsContainer.innerHTML = `<p>${t.errorLoading}</p>`;
      }
    }

    // Testing mode execution - runs after all functions are defined
    if (TESTING_MODE) {
      console.log('🧪 TESTING MODE ENABLED - Loading recommendations directly');

      // Initialize quiz answers with default values for testing
      // Use actual quiz option values to ensure products load
      quizAnswers.hair_diameter = 'Moyens / normaux';
      quizAnswers.hair_texture = 'Lisses';
      quizAnswers.hair_color = 'Brun';
      quizAnswers.hair_state = ['Endommagés'];
      quizAnswers.main_concern = ['Manque de volume', 'Manque de brillance'];

      // Show the results step immediately (step 7)
      const resultsStep = quizSection.querySelector('[data-step="7"]');
      if (resultsStep) {
        resultsStep.classList.add('active');

        // Hide all other steps
        quizSection.querySelectorAll('.quiz-step').forEach((step) => {
          if (step !== resultsStep) {
            step.classList.remove('active');
          }
        });

        // Hide quiz header and progress
        const quizHeader = quizSection.querySelector('.quiz-header');
        if (quizHeader) {
          quizHeader.style.display = 'none';
        }

        // Hide navigation buttons
        const navigation = quizSection.querySelector('.quiz-navigation');
        if (navigation) {
          navigation.style.display = 'none';
        }

        // Load recommendations immediately
        setTimeout(() => {
          console.log('🧪 Loading recommendations...');
          loadRecommendations();
        }, 500);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
